import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { SubHeader, Input } from '../../components/'

const Address = ({addressInfo}) => {
  const currentAddress = addressInfo ? addressInfo :
    {
      addressNumber: "",
      buildingVillage: "",
      soi: "",
      street: "",
      subDistrict: "",
      district: "",
      city: "",
      zipCode: ""
    };

  return (
    <>
      <SubHeader text="Contact Address" />
      <Row className="pt-2">
        <Col>
          
          <Input text="Address Number" placeholder="address number" disabled={true} name="addressNumber" required value={currentAddress["addressNumber"]} />
        </Col>
        <Col>
          <Input text="Building/Village" placeholder="building/village" disabled={true} name="buildingVillage" value={currentAddress["buildingVillage"]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input text="Soi" disabled={true} name="soi" value={currentAddress["soi"]} />
        </Col>
        <Col>
          <Input text="Street" disabled={true} name="street" value={currentAddress["street"]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input text="Sub-District" placeholder="sub-district" required disabled={true} name="subDistrict" value={currentAddress["subDistrict"]} />
        </Col>
        <Col>
          <Input text="District" disabled={true} name="district" required value={currentAddress["district"]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input text="City" disabled={true} name="city" required value={currentAddress["city"]} />
        </Col>
        <Col>
          <Input text="Zip Code" placeholder="zip code" required disabled={true} name="zipCode" value={currentAddress["zipCode"]} />
        </Col>
      </Row>
    </>
  )
}

export default Address
